// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ExtLinkClientTab;
(function (ExtLinkClientTab) {
    ExtLinkClientTab["MORE"] = "More";
    ExtLinkClientTab["ACCOUNT"] = "Account";
    ExtLinkClientTab["TOOLS"] = "Tools";
    ExtLinkClientTab["HELP"] = "Help";
    ExtLinkClientTab["CUSTOM_TAB"] = "Custom tab";
    ExtLinkClientTab["MOBILE_APPS"] = "MobileApps";
})(ExtLinkClientTab || (ExtLinkClientTab = {}));
